import React from 'react';

import { useLoadFavoriteFilters, useUpdateFavoriteFilters } from './data';

const withFavorites = (Component) =>
  React.forwardRef(({ screen, ...props }, ref) => {
    const { data } = useLoadFavoriteFilters({ screen });

    const [updateFavoriteFilters] = useUpdateFavoriteFilters({ screen });

    const handleChangeFavorites = (favorites) =>
      updateFavoriteFilters({ favorites });

    return (
      <Component
        screen={screen}
        favorites={data}
        onChangeFavorites={handleChangeFavorites}
        ref={ref}
        {...props}
      />
    );
  });

export default withFavorites;
